import { FormComponent } from "@/Common/Models/Forms/FormTemplateInterfaces";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";

abstract class ComponentRenderer {
    protected component: FormComponent;
    protected answers: QuestionnaireAnswer[];

    constructor(component: FormComponent, answers: QuestionnaireAnswer[]) {
        this.component = component;
        this.answers = answers?.filter(x => this.areAnswersOfComponent(x.PropertyPath)) ?? [];
    }

    protected abstract areAnswersOfComponent(formPath: string): boolean;

    public abstract render(onChange?: (answer: QuestionnaireAnswer) => void, disabled?: boolean): JSX.Element;
    public abstract isValid(): boolean;
}

export { ComponentRenderer };
